import { FontWeights, IProcessedStyleSet, mergeStyleSets } from 'office-ui-fabric-react';
import { AppVoiceRecorderStyles } from './AppVoiceRecorder.props';
import { AppLayoutSettings } from '../../pages/common.styles';

export const getAppVoiceRecorderStyles = (
  customStyles?: Partial<AppVoiceRecorderStyles>
): IProcessedStyleSet<AppVoiceRecorderStyles> => {
  const styles: AppVoiceRecorderStyles = {
    root: {
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    timer: {
      fontSize: AppLayoutSettings.AppFontSize.extraLargeFontSizePx,
      fontWeight: FontWeights.regular,
      fontFamily: 'Bahnschrift, "Bahnschrift Web", "Segoe UI", "Helvetica Neue"',
      color: AppLayoutSettings.getAppColorContainer().darkLabelColor.value
    },
    micWidgetContainer: {
      marginTop: '26px'
    },
    statusLabelContainer: {
      marginTop: '40px',
    },
    statusLabel: {
      color: AppLayoutSettings.getAppColorContainer().darkLabelColor.value
    },
    buttonContainer: {
      marginTop: '36px'
    }
  };

  return mergeStyleSets(styles, customStyles);
};
